import { ReactElement } from "react";
import { DialogTrigger, Modal, Dialog } from "react-aria-components";

import Button from "~/ui/Button/Button";

interface ISearchDialog {
    children: ReactElement;
    open: boolean;
}

const SearchDialogModal = ({ children, open }: ISearchDialog) => {
    return (
        <DialogTrigger>
            <Button className="!hidden" />
            <Modal className="bg-stone-darkest/40 backdrop-blur-sm fixed inset-0 z-20" isOpen={open}>
                <Dialog className="grid place-content-center h-full focus-visible:outline-none">
                    {() => (
                        <div className="flex flex-col items-center min-w-[40rem] max-w-6xl min-h-40 rounded-2xl bg-white relative">
                            {children}
                        </div>
                    )}
                </Dialog>
            </Modal>
        </DialogTrigger>
    );
}

export default SearchDialogModal;
